import { render, staticRenderFns } from "./quota-settings-widget.vue?vue&type=template&id=d65530ca"
import script from "./quota-settings-widget.vue?vue&type=script&lang=js"
export * from "./quota-settings-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports